(function($) {
    var items = [];

    $('.presse__year-nav-item').click(function(e) {
        e.preventDefault();
        $('.presse__year-nav-item').removeClass('active');
        $(this).addClass('active');

        var year = $(this).attr('data-year');
        $('.presse__item').removeClass('active show');
        $('.presse__item[data-year="' + year + '"').addClass('active');
        setTimeout(function() {
            $('.presse__item[data-year="' + year + '"').addClass('show');
        }, 1)

        resetSliderItems();
    });

    var resetSliderItems = function() {
        items = [];

        $('.presse__item.active > .presse__image').each(function( index ) {
          var src = $( this ).attr('data-url');
          var w = $( this ).attr('data-width');
          var h = $( this ).attr('data-height');
          var title = $( this ).attr('data-title');
          var index = $( this ).attr('data-index');

          items.push({
            index: parseInt(index),
            src: src,
            w: parseInt(w),
            h: parseInt(h),
            title: title
          });

        });
    }

    var openPhotoSwipe = function(index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
                
        // define options (if needed)
        var options = {
            // history & focus options are disabled on CodePen        
            index: index,
            history: false,
            focus: false,

            showAnimationDuration: 0,
            hideAnimationDuration: 0
            
        };
        
        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    resetSliderItems();

    $('.js-open-photoswipe').click(function(e) {
        e.preventDefault();
        var itemIndex = parseInt($(this).attr('data-index'));
        var indexInItems = items.map(function (item) { return item.index; }).indexOf(itemIndex);
        openPhotoSwipe(indexInItems);
    });

})(jQuery); // Fully reference jQuery after this point.